export const getEmployeeChangeLogCountForOrg = (
  countEmployeeChangeLogs?: Record<string, number>,
  orgId?: number | null,
) => {
  const employeeChangeLogCountsKey = String(orgId || 'total');
  return countEmployeeChangeLogs ? countEmployeeChangeLogs[employeeChangeLogCountsKey] || 0 : 0;
};
